import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Row, Col, ListGroup, Card } from 'react-bootstrap';
import { useGetStoreIncomeDetailsQuery } from '../slices/storeIncomesApiSlice';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Meta from '../components/Meta';
import StoreIncomeCarousel from '../components/StoreIncomeCarousel';

const StoreIncomeScreen = () => {
  const { id: storeIncomeId } = useParams();
  const { data: storeIncome, isLoading, error } = useGetStoreIncomeDetailsQuery(storeIncomeId);

  const renderStoreIncomeDetails = () => (
    <>
      <Meta title={storeIncome.date} description={storeIncome.account} />
      <Row>
        <Col md={6}>
          {/* Display storeIncome images using StoreIncomeCarousel */}
          {storeIncome.images && storeIncome.images.length > 0 ? (
            <StoreIncomeCarousel images={storeIncome.images} />
          ) : (
            <Message variant="info">No images available for this storeIncome</Message>
          )}
        </Col>
        <Col md={3}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h3>{storeIncome.accountName}</h3>
            </ListGroup.Item>
            <ListGroup.Item>Details: {storeIncome.details}</ListGroup.Item>
            <ListGroup.Item>Amount: {storeIncome.amount}</ListGroup.Item>
            <ListGroup.Item>
              Category: {storeIncome.category}
            </ListGroup.Item>
            <ListGroup.Item>Notes:{storeIncome.notes}</ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={3}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <Row>
                  <Col>Amount:</Col>
                  <Col>
                    <strong>{storeIncome.amount}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>User:</Col>
                  <Col>
                    {storeIncome.username}
                  </Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
          <div className="storeIncome-images mt-3">
                    <h6>Images:</h6>
                    <div className="image-thumbnails">
                      {storeIncome.images?.map((image, index) => (
                        <img
                          key={index}
                          src={image}
                          alt={` ${index + 1}`}
                          className="thumbnail-img"
                          style={{
                            width: '50px',
                            height: '50px',
                            marginRight: '5px',
                            borderRadius: '5px',
                          }}
                        />
                      ))}
                    </div>
                  </div>
        </Col>
      </Row>
    </>
  );

  return (
    <>
      <Link className="btn btn-light my-3" to="./screens/admin/NetCash">
        Go Back
      </Link>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">
          {error?.data?.message || error.error}
        </Message>
      ) : (
        renderStoreIncomeDetails()
      )}
    </>
  );
};

export default StoreIncomeScreen;